import { render, staticRenderFns } from "./ElectronicPayrollList.vue?vue&type=template&id=053e02c9"
import script from "./ElectronicPayrollList.vue?vue&type=script&lang=js"
export * from "./ElectronicPayrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports